module.exports = __webpack_public_path__ + "img/2@2x.d9ed2be0.png";